import { type IDeepOmit, type IDeepReplaceSuffix, IEnumContractStatus } from '@bcc-life/sandbox';

import { type ruTranslations } from '~/consts/i18n/ru';

export const kzTranslations: IDeepReplaceSuffix<
  IDeepOmit<typeof ruTranslations, `${string}_few`>,
  '_many',
  '_other'
> = {
  translation: {
    additionalAgreement: {
      activeSince: 'Қолданыста:',
      activityChanged: 'Қызмет түрі өзгерді — тәуекел сыныбы мен тариф қайта есептелді',
      addBranch: 'Филиал қосу',
      agreementNumber: 'Келісім нөмірі',
      banner: {
        rejectedTitle: '{{number}} өтінімін менеджер қабылдамады',
        text: 'Қосымша келісім бойынша менеджерге хабарласыңыз',
        title: 'Қосымша келісім',
      },
      binNotFound: 'Бұл БСН бойынша ұйым табылмады',
      branch: 'Филиал',
      cancel: 'Болдырмау',
      cancelConfirm: 'Енгізілген деректер сақталмайды. Қосымша келісімді ресімдеуді болдырмайсыз ба?',
      cancelTitle: 'Ресімдеуді болдырмау',
      changed: 'Деректер өзгерді',
      continueDraft: 'Ресімдеуді жалғастыру',
      contractNumber: 'Шарт №',
      corrected: 'Түзетілген деректер',
      create: 'Жасау',
      createAgreement: 'Қосымша келісім жасау',
      documentBase: 'Негіздеме құжат',
      documentDate: 'Құжат күні',
      documentNumber: 'Құжат нөмірі',
      documentRequired: 'Негіздеме құжатын толтырыңыз: түрі, нөмірі және күні',
      draftModal: {
        text: 'Бұл шарт бойынша аяқталмаған қосымша келісім өтінімі бар. Ресімдеуді жалғастырасыз ба?',
        title: 'Қосымша келісім',
      },
      duplicateBin: 'Бұл БСН бар ұйым құрамға кіреді',
      headOffice: 'Бас кеңсе деректері',
      initial: 'Бастапқы деректер',
      listTitle: 'Қосымша келісімдер',
      noChanges: 'Өтінім жіберу үшін кемінде бір мәнді өзгертіңіз',
      number: 'Нөмір',
      oked: 'ЭҚЖЖ',
      phone: 'Телефон нөмірі',
      policyholderData: 'Сақтанушы деректері',
      recalculating: 'Сома қайта есептеліп жатыр — қорытынды жаңартылғанша күтіңіз',
      registrationDate: 'Тіркелген күні',
      registrationDepartment: 'Әділет органы',
      removeBranch: 'Филиалды жойғыңыз келе ме?',
      removeBranchConfirm: 'Филиалды жойғыңыз келетініне сенімдісіз бе?',
      removeBranchQuestion: 'Филиалды жойғыңыз келетініне сенімдісіз бе?',
      reRegistrationDate: 'Қайта тіркелген күні',
      riskClass: 'Кәсіптік тәуекел сыныбы',
      sent: 'Қосымша келісімге өтінім жіберілді',
      signer: 'Қол қоюшы',
      signerIin: 'Қол қоюшының ЖСН',
      signerJobName: 'Лауазымы',
      signerJobNameOther: 'Басқа лауазым',
      status: 'Мәртебе',
      statuses: {
        ACTIVATING: 'Белсендірілуде',
        ACTIVE: 'Қолданыста',
        APPROVED: 'Келісілді',
        AWAITING_BCC_LIFE_SIGNATURE: 'BCC Life қолын күтуде',
        AWAITING_CLIENT_SIGNATURE: 'Сіздің қолыңызды күтуде',
        DRAFT: 'Жоба',
        INVOICE_ISSUED: 'Шот қойылды',
        PAID: 'Төленді',
        PENDING_DS_MANAGER: 'Келісуде',
        PENDING_STATISTICIAN: 'Статисте',
        REJECTED_BY_DS_MANAGER: 'Қабылданбады',
        RETURNED_BY_STATISTICIAN: 'Пысықтауға қайтарылды',
        SIGNED: 'Қол қойылды',
      },
      steps: {
        branches: 'Филиалдар деректері',
        contract: 'Шарт деректері',
        headOffice: 'Бас кеңсе деректері',
      },
      surcharge: 'Қосымша төлем сомасы(алдын ала есеп)',
      title: 'Қосымша келісім',
      yes: 'Иә',
    },
    agreement: {
      userAgreement: 'Пайдаланушы келісімінің шарттары',
    },
    annuity: {
      annuityApplication: 'Заявление на ППА',
      applicationNumber: '№ заявления',
      applyAnnuity: 'Подать заявление на ППА',
      submitApplication: 'Ваше извещение прошло все проверки и теперь вы можете подать заявление на ППА',
      whatNext: 'Что дальше',
    },
    applications: {
      application: 'Өтінім',
      applications: 'Мәлімдеме',
      notFound: 'Мұнда әзірше ештеңе жоқ',
    },
    auth: {
      agrrement: 'Мен Пайдаланушы келісімінің шарттарын оқыдым және келісемін',
      bin: 'БСН/ЖСН',
      cyberHygiene: {
        copy: 'Маңызды деректердің (фотосуреттер, құжаттар, байланыс деректері) резервтік көшірмелерін үнемі жасап отырыңыз және оларды қауіпсіз жерде сақтаңыз.',
        hygiene: 'Кибергигиена: Сандық кеңістікті қорғаудағы сіздің рөліңіз.',
        info: 'Заманауи сандық  әлемде кибергигиена өте маңызды – қарапайым ережелерді сақтау сізді және сіздің деректеріңізді алаяқтардан қорғауға көмектеседі.',
        link: 'Кіретін веб-сайттардың URL-мекенжайларын тексеріңіз, тек ресми дереккөздерге ғана сенім артыңыз. Күмәнді сілтемелерге өтпеңіз және белгісіз жіберушілердің тіркемелерін ашпаңыз.',
        password:
          'Құрамында әріптер (үлкен және кіші регистрде), сандар мен арнайы таңбалар бар күрделі құпиясөздерді пайдаланыңыз. Құпиясөздерді тұрақты түрде ауыстырып отырыңыз.',
        personalInfo:
          'Әлеуметтік желілерде және жалпы қолжетімді ресурстарда жеке деректеріңізді (мекенжай, телефон нөмірі, туған күніңіз) жарияламаңыз.',
        recommended: 'Ұсынылатын қауіпсіздік шаралары:',
        safety:
          'Кибергигиенаның осы қарапайым ережелерін сақтау сізге және жақындарыңызға сандық  әлемде қауіпсіз болуға көмектеседі. Есіңізде болсын: интернеттегі қауіпсіздік – бәріміздің ортақ жауапкершілігіміз.',
        update:
          'Антивирустық бағдарламалық жасақтаманы орнатып, оны үнемі жаңартып отырыңыз. Антивирусты автоматты түрде жаңарту функциясын қосыңыз.',
      },
      email: 'Email',
      emailOtpMessage: 'Сіздің электронды поштаңызға бір реттік растау коды жіберіледі',
      enter: 'Кіру',
      enterCode: 'Кодты енгізіңіз',
      errors: {
        basic: 'Қате орын алды, кейінірек қайталап көріңіз',
        bccMail: 'info@bcclife.kz',
        INCORRECT_PHONE_NUMBER:
          'Құрметті клиент, сіздің телефон нөміріңіз тіркелмеген. Көмек алу үшін Қолдау қызметіне хабарласыңыз info@bcclife.kz',
        notFound: 'Енгізілген ЖСН бойынша пайдаланушы табылмады. Тіркеліңіз.',
        notNumber: 'Нөмір тіркелмеген',
        otpCodeNotValid: 'Жіберілген СМС-код дұрыс емес. Қайтадан көріңіз.',
        USER_BLOCKED: 'Енгізілген номер блокталған.',
        USER_EXISTS_BY_BIN: 'Енгізілген БСН/ЖСН алдында тіркелген. Жүйеге кіріңіз',
        USER_EXISTS_BY_IDENTIFIER: 'Енгізілген БСН/ЖСН уже тіркелген. Жүйеге кіріңіз.',
        USER_EXISTS_BY_PHONE: 'Енгізілген номер уже тіркелген. Жүйеге кіріңіз.',
        USER_NOT_FOUND: 'Енгізілген номер әлі тіркелмеген. Тіркеліңіз.',
        userNotFound: 'Енгізілген телефон нөмірі бар пайдаланушы табылмады',
      },
      getCode: 'Кодты алу',
      getSms: 'Кодты алу',
      haveAnAccount: 'Сіз әлдеқашан тіркелгенсіз бе?',
      iin: 'БСН/ЖСН',
      login: 'Кіру',
      loginBy: 'Бойынша кіру',
      mail: 'сіздің поштаңыз',
      noAccount: 'Сіз тіркелмегенсіз бе?',
      otpCode: 'ОТР-код',
      otpMessage: 'Нөміріңізді растау үшін телефоныңызға OTP коды жіберіледі',
      phone: 'нөміріне жібердік ',
      phoneNumber: 'Телефон нөмірі',
      phoneRadio: 'Телефон нөмірі',
      register: 'Тіркелу',
      registration: 'Тіркеу',
      repeatedCode: 'Кодты қайта сұрау',
      repeatedCodeInSeconds: 'Кодты {{seconds}} уақытта қайта сұрай аласыз',
      sentCodeOne: 'Біз кодты ',
      sentCodeToEmail: 'Біз сіздің поштаңызға код жібердік',
      sentCodeToPhone: 'Біз сіздің нөміріңізге код жібердік',
      sentCodeTwo: ' нөміріне жібердік',
      subscribe: 'Қол қою',
      welcome: 'Қош келдіңіз',
    },
    bankName: {
      bcc: 'ЦентрКредит Банкі',
      forte: 'ForteBank',
      halyk: 'Қазақстан Халық Банкі',
      kaspi: 'Kaspi Bank',
    },
    chooseLanguage: 'Тілді таңдаңыз',
    claimDocuments: {
      requirement: {
        documentTemplate: 'Шаблон документа',
        listDocuments: 'Список приложенных документов',
        requestDocuments:
          'Для подачи заявления на выплату необходимо собрать и предоставить перечень необходимых документов.',
        requiredDocuments: 'Перечень необходимых документов',
        templateTitle: 'Шаблон документа о заработной плате.xlsx',
        verificationDocuments: 'Сбор и проверка документов',
      },
    },
    claimsStatements: {
      applicationPage: ' Страница заявления',
      clientIdentifier: 'ИИН/БИН клиента',
      clients: {
        absent: 'Отсутствует',
        additionalInfo: 'Иная информация',
        additionalInfoIfPresent: 'Иная информация (при наличии)',
        addRepresentative: 'Добавить представителя',
        bankCode: 'КБе',
        bankName: 'Наименование банка',
        bankRequisites: 'Банковские реквизиты',
        beneficialControlType: 'Порядок осуществления бенефициарным собственником контроля',
        benificiar: 'Бенифициар',
        bikCode: 'БИК',
        binCode: 'БИН банка',
        birthAddress: 'Место рождения',
        birthDate: 'Дата рождения',
        checkInformation:
          'Проверьте, пожалуйста, указанные данные. Если информация неверна или устарела, перейдите на страницу договора в личном кабинете и обновите её.',
        citizenship: 'Гражданство',
        clarifyIsPdl: 'Уточнение ПДЛ',
        comment: 'Комментарий',
        countryResidence: 'Страна резидентства',
        dataBeneficialOwner: 'Данные по бенефициарным собственникам',
        director: 'Директор',
        economicActivity: 'Вид экономической деятельности или ОКЭД',
        economicSector: 'Код сектора экономики',
        entity: 'Юридических лиц',
        expireDate: 'Дата окончания действия документа',
        fio: 'ФИО',
        fioBeneficial: ' ФИО бенефициара',
        fioFirstManager: 'ФИО первого руководителя',
        fioFounder: 'ФИО учредителя',
        fioTitle: 'ФИО/Название',
        fioVictim: 'ФИО потерпевшего',
        firstManager: 'Данные по первому руководителю',
        founder: 'Учредитель',
        foundersLength: 'Общее количество участников, учредителей',
        fullAddress: 'Место нахождения организации',
        gender: 'Пол представителя',
        genderVictim: 'Пол потерпевшего',
        iban: 'IBAN',
        iin: 'ИИН',
        iinBin: 'ИИН/БИН',
        iinCountryRegistration: 'ИИН в стране регистрации',
        iinFirstManager: 'ИИН первого руководителя',
        iinPolicyholder: 'БИН/ИИН Страхователя',
        iinSoloPolicyholder: 'ИИН Страхователя',
        iinVictim: 'ИИН потерпевшего',
        individual: 'Физических лиц',
        infBeneficialOwner: 'Сведения по бенефициарному собственнику',
        infFounder: 'Данные по учредителю',
        infoAboutVictim: 'Данные о потерпевшем',
        infoRepresentative: 'Данные по представителю',
        informationFounder: 'Сведения по учредителю',
        infoVictim: 'Данные потерпевшего',
        isPdl: 'Принадлежит ли и/или причастен ли к ПДЛ, его супруге (супругу) и близким родственникам',
        isResidence: 'Признак резидентства',
        issueDate: 'Дата выдачи документа',
        issueOrganization: 'Выдано(кем)',
        legalAddress: 'Юридический адрес',
        nameHostOrganization: 'Наименование принимающей организации',
        naming: 'Наименование',
        numberDocument: '№ документа',
        oked: 'Основной ОКЭД',
        orgFullName: 'Полное наименование Страхователя',
        orgIncorporationDepartment: 'Орган юстиции, зарегистрировавший орг.',
        orgIncorporationLastDate: 'Дата перерегистрации',
        policyholder: 'Данные страхователя',
        region: 'Регион',
        registrationAddress: 'Адрес регистрации',
        registrationCertificate: {
          certificateSeries: 'Серия',
          notificationDate: 'Дата регистрации',
          number: 'Номер',
          title: 'Свидетельство о регистрации',
        },
        registrationDate: 'Дата регистрации',
        registrationNumber: 'Гос. регистрационный номер',
        representative: 'Представитель',
        residenceCountry: 'Страна резиденства',
        residentialAddress: 'Фактический адрес / Место проживания',
        riskClass: 'Класс профессионального риска',
        talon: 'Талон',
        talonNotifyCreated: 'Дата приема уведомления по талону',
        talonNumber: 'Номер талона',
        taxResidenceCountry: 'Налоговое резидентство',
        type: 'Тип',
        typeDocument: 'Вид документа',
      },
      contractNumber: 'Номер договора',
      documents: {
        beneficiaryConsent: 'Пайда алушының келісімі',
        certificate: 'Қабылданған құжаттар туралы анықтама',
        paymentStatement: 'Төлемге өтініш',
        victimConsent: 'Зардап шегушінің келісімі',
      },
      download: 'Скачать заявление',
      enterClientIdentifier: 'Введите ИИН / БИН клиента',
      enterContractNumber: 'Введите номер договора',
      enterStatementId: 'Введите ID заявления',
      enterStatementNumber: 'Введите номер заявления',
      enterVictimFio: 'Введите ФИО потерпевшего',
      enterVictimIdentifier: 'Введите ИИН потерпевшего',
      generatedPaymentPdf: 'Қалыптастырылған төлемге өтініш.pdf',
      informationApplication: 'Данные по заявлению',
      noticeNumber: '№ извещения',
      noticeType: 'Тип заявления',
      product: 'Продукт',
      sentApplication:
        'Заявление успешно отправлено и сейчас находится в обработке. Пожалуйста, дождитесь решения страховой компании — мы уведомим вас, как только оно будет принято.',
      statementDate: 'Дата заявления',
      statementId: 'ID Заявления',
      statementNumber: 'Номер заявления',
      title: 'Заявления на выплату',
      victimFio: 'ФИО потерпевшего',
      victimIdentifier: 'ИИН потерпевшего',
    },
    clear: 'Очистить',
    common: {
      currency: 'Валюта',
    },
    contractsPage: {
      annualWageFund: 'ГФОТ',
      annuityPayment: 'Аннуитетная выплата',
      averageMonthlySalary: 'Средне-месячная зарплата',
      beginDate: 'Дата начала страховой защиты',
      branchesData: 'Данные филиалов',
      branchNumber: 'Филиал {{number}}',
      cardDocument: 'Карточка электронного документа',
      cardDocumentEnpf: 'Карточка электронного документа ЕНПФ',
      conclusionDate: 'Дата заключения',
      consent: 'Согласие на сбор и обработку данных ЕНПФ',
      contract: 'Договор',
      contractPdf: 'Договор',
      contracts: 'Шарттар',
      cover: 'Жабын',
      coverageLife: '1. Смерть 2. Инвалидность 3. Временная утрата трудоспособности',
      ddc: 'Карточка электронного документа',
      disabilityStatus: 'Наличие инвалидности',
      dpvSum: 'Сумма ДПВ',
      dpvSumTooltip: 'ДПВ — это дополнительные пенсионные взносы, которые вы сами вносите на отдельный счет в ЕНПФ.',
      dsjProgram: 'Бағдарлама',
      dsjPrograms: {
        COMFORT: 'Комфорт',
        STANDARD: 'Стандарт',
      },
      dsjRisks: {
        DEATH_ANY_CAUSE: 'Кез келген себеппен қайтыс болу',
        DISABILITY_1_2: 'I және II топтағы мүгедектік',
        TEMPORARY_DISABILITY: 'Еңбекке уақытша жарамсыздық',
      },
      employeesCount: 'Количество сотрудников',
      endDate: 'Дата окончания страховой защиты',
      endowmentCover:
        '1.  Полистің мерзімі аяқталғанға дейін өмір сүруі 2. Жазатайым оқиға немесе ауру салдарынан қайтыс болу',
      exchangeRateAtTheTimeOfPurchase: 'Курс валюты на момент покупки',
      ezSigner: 'Представление ezSigner',
      ezSignerEnpf: 'Представление ezSigner ЕНПФ',
      gpEndDate: 'Дата окончания гарантированного периода',
      gpStartDate: 'Дата начала гарантированного периода',
      guaranteedPaymentTerm: 'Гарантированный срок выплат',
      guaranteedPaymentYears: 'Гарантированный срок выплат в годах',
      infoContract: 'Данные договора',
      insuranceAmount: 'Страховая сумма',
      insuranceAmountInCurrency: 'Страховая сумма в валюте',
      insuranceApplication: 'Заявление на страхование',
      insuranceCoefficient: 'ПК',
      insuranceDividend: 'Страховой дивиденд',
      insurancePremium: 'Страховая премия',
      insurancePremiumWithCoefficient: 'Страховая премия с учетом ПК',
      labelAlert: 'Внимание! По данному договору было направлено Заявление на расторжение',
      lifeCover:
        '1. Сақтанушының қайтыс болуы 2. Жазатайым оқиға немесе ауру салдарынан 1 немесе 2 топтағы мүгедектікті белгілеу 3. Жазатайым оқиға нәтижесінде уақытша еңбекке жарамсыздық',
      listDocuments: 'Список документов',
      // TODO(BL-6014): нужен казахский перевод для ключей рассрочки (nextPayment*, paid*, payment*, remainingToPay, tranche*)
      mainOffice: 'Головной офис',
      mainOked: 'Основной ОКЭД',
      nextPaymentAmount: 'Сумма платежа',
      nextPaymentDate: 'Дата платежа',
      nextPaymentDeadline_one: 'Внимание! Следующий платеж необходимо внести в течение {{count}} дня',
      nextPaymentDeadline_other: 'Внимание! Следующий платеж необходимо внести в течение {{count}} дней',
      nextPaymentDeadlineToday: 'Внимание! Следующий платеж необходимо внести сегодня',
      nextPaymentDownloadInvoice: 'Скачать счет на оплату',
      nextPaymentInfo: 'Информация о следующем платеже',
      noData:
        'Шарттарыңызға сәйкес келетін шарттар жоқ. Егер сіз сүзгілерді немесе іздеу сұрауын қолданған болсаңыз — оларды өзгертіп көріңіз.',
      opvSum: 'Сумма ОПВ',
      opvSumTooltip: 'ОПВ — это обязательные пенсионные взносы, из которых формируется основная пенсия.',
      organizationLocation: 'Место нахождения организации',
      osrnsCover: '1. Қызметкердің кетуі 2. Кәсіби жұмыс қабілеттілігін 30%-дан 100%-ға дейін жоғалту',
      osrnsEzSigner: 'Представление ezSigner',
      paidByContract: 'Оплачено по договору',
      paidLabel: 'Оплачено',
      paymentInvoice: 'Счет на оплату',
      paymentInvoiceNextDate: 'Дата следующего платежа',
      paymentStatusCancelled: 'Отменен',
      paymentStatusPaid: 'Оплачен',
      paymentStatusPartiallyPaid: 'Частично оплачен',
      paymentStatusUnpaid: 'Не оплачен',
      policyHolderBin: 'БИН Страхователя',
      policyHolderFullName: 'Полное наименование Страхователя',
      product: 'Продукт',
      referralProgram: 'Жолдамалық бағдарлама',
      referralProgramDescription:
        'Жеке жолдамалық сілтемеңізді жасап, оны достарыңызбен немесе таныстарыңызбен бөлісіңіз. Егер сіздің жолдамалық сілтемеңіз арқылы шарт рәсімделсе, жолдамалық бағдарламаның талаптарына сәйкес сыйақы аласыз.',
      remainingToPay: 'Остаток к оплате',
      riskClassShort: 'КПР',
      selfAmount: 'Сумма собственных средств',
      selfAmountTooltip: 'Личные средства, которые вы внесли в BCC Life.',
      tariff: 'Тариф',
      textAlert: 'Для отслеживания статуса по расторжению, пожалуйста, перейдите во вкладку "Расторжение"',
      totalAnnuityCost: 'Итого стоимость аннуитета',
      tranche: '{{number}}-й транш',
      trancheDueDate: 'Дата оплаты {{date}}',
      trancheFirst: 'Первый транш',
      trancheFourth: 'Четвертый транш',
      tranchePaidPercent: '{{percent}}% оплачено',
      trancheRemaining: 'Остаток: {{amount}}',
      trancheSecond: 'Второй транш',
      trancheThird: 'Третий транш',
      yourContracts: 'Сақтандыру шарттары',
    },
    details: {
      contractEndowmentName: 'Индекстелген өмірді сақтандыру шарты',
      contractLifeName: 'Өмірді сақтандыру шарты',
      contractNumber: 'Шарт нөмірі',
      contractOSRNSName: 'Қызметкерді сақтандыру шарты',
      contractsNumber: '№ договора',
      contractTerminate: 'Расторгнуть договор',
      date: 'Өтініштің күні мен уақыты:',
      dateUpdate: 'Соңғы жаңартудың күні мен уақыты:',
      download: 'Жүктеу',
      insuranceAmount: 'Сақтандыру сомасы',
      insurancePremium: 'Сақтандыру сыйлықақысы',
      insured: 'Сақтандырылған адам:',
      moreDetailed: 'Толығырақ',
      notifyInsured: 'Известить о страховом случае',
      status: 'Сақтандыру шартының жағдайы:',
    },
    detailsPage: {
      accept: 'Сіздің төлем туралы өтінішіңіз қабылданды',
      acceptText:
        '5 күн ішінде төлем сіздің шотыңызға түседі. Сұрақтар туындаған жағдайда Қолдау қызметіне хабарласыңыз.',
      attackIt: 'Файлды тіркеңіз',
      attention14Days:
        'С момента заключения договора страхования прошло 14 дней. В соответствии с условиями договора, в случае его расторжения уплаченная сумма не подлежит возврату.',
      attentionText:
        'Мәлімделген оқиға бойынша Сіздің өтінішіңізді қарау үшін келесі құжаттар жиынтығын ұсынуыңызды сұраймыз:',
      attentionTitle: 'Назар аударыңыз! Құжаттарды жүктеу қажет',
      certified: 'Назар аударыңыз! Қажетті құжаттың көшірмелері нотариалды куәландырылуы тиіс',
      choose: 'Файлды таңдаңыз',
      confirmation: 'Мен барлық қажетті құжаттарды жүктегенімді растаймын',
      data: 'Деректер:',
      fileFormat: 'Допустимые форматы загрузки файлов: pdf. Размер загружаемого файл не должен превышать 30 MB.',
      format:
        'Жүктелетін файлдардың рұқсат етілген  форматтары: pdf, doc, docx, jpg, jpeg, png, svg. Жүктелетін файл өлшемі 30 Мб-тан аспауы керек.',
      reasonTermination: 'Для рассмотрения Вашего обращения, пожалуйста, укажите причину расторжения договора',
      rejected: 'Сіздің өтінішіңіз қабылданбады',
      rejectedText: 'Қабылдамау себебі туралы ақпарат алу үшін Қолдау қызметіне хабарласыңыз',
      requiredDocuments: 'Міндетті құжаттар тізімі',
      select: 'Файлды сүйреңіз немесе компьютерден таңдаңыз',
      send: 'Жіберу',
      stepFour: '4 қадам',
      stepFourText: 'Өтініш қабылданды',
      stepOne: '1 қадам',
      stepOneText: 'Сақтандыру жағдайы туралы хабарлама',
      stepThree: '3 қадам',
      stepThreeText: 'Сақтандыру төлеміне өтініш беру',
      stepTwo: '2 қадам',
      stepTwoText: 'Құжаттарды жүктеу',
    },
    download: 'Скачать',
    error: {
      notFound: 'Страница не найдена',
      notifyInsured: 'Известить о страховом случае',
      reloudPage: 'Попробуйте перезагрузить страницу',
    },
    faq: 'Жиі қойылатын сұрақтар',
    general: {
      address: 'Адрес',
      begin: 'Начать',
      birthDate: 'Дата рождения',
      citizenship: 'Гражданство',
      client: 'Клиент',
      clientStatus: {
        NEW: 'Извещение на согласовании',
      },
      conclusionDate: 'Дата заключения',
      contact: {
        contactInfo: 'Контактные данные',
        email: 'E-mail',
        phoneNumber: 'Номер телефона',
      },
      createdDate: 'Дата создания',
      documentNumber: 'Номер документа',
      enterClientFio: 'Введите ФИО клиента',
      enterConclusionDate: 'Введите дату заключения',
      enterContractId: 'Введите ID договора',
      enterContractNumber: 'Введите номер договора',
      enterIinBin: 'Введите ИИН / БИН',
      enterInsuranceAmount: 'Введите страховую сумму',
      enterInsuranceEndDate: 'Введите дату окончания страховой защиты',
      enterInsurancePremium: 'Введите страховую премию',
      enterInsuranceStartDate: 'Введите дату начала страховой защиты',
      executor: 'Исполнитель',
      gender: 'Пол',
      iinBinClient: 'ИИН / БИН клиента',
      insuranceEndDate: 'Дата окончания страховой защиты',
      insuranceStartDate: 'Дата начала страховой защиты',
      naming: 'Наименование',
      note: 'Примечание',
      notFound: 'Табылмады',
      optionLists: {
        contractStatuses: {
          [IEnumContractStatus.ACTIVE]: 'Действующий',
          [IEnumContractStatus.EXPIRED]: 'Завершен',
          [IEnumContractStatus.IN_PROCESSING_PAYMENT]: 'Требуется обработка заявления',
          [IEnumContractStatus.REPLACED]: 'Жарамсыз',
          [IEnumContractStatus.TERMINATED]: 'Расторгнут',
          [IEnumContractStatus.WAITING_FOR_PAYMENT_APPLICATION]: 'Ожидаем заявления на выплату',
        },
      },
      registrationAddress: 'Адрес регистрации',
      status: 'Статус',
      tableNoData:
        'Нет записей по заявкам, соответствующих вашим условиям. Если вы применили фильтры или поисковый запрос - попробуйте их изменить.',
      thanks: 'Спасибо!',
      underwriter: 'Ответственный',
      updatedDate: 'Дата редактирования',
    },
    noDocuments: {
      goSite: 'Сайтқа өтіңіз',
      notice: 'вы можете подать извещение о страховом случае',
      site: 'Сіз бағдарламалармен біздің сайтта таныса аласыз',
    },
    notice: {
      infoMessages: {
        accidentActNotReceived:
          'необходимо предоставить в оригинале лично по адресу: город Алматы, проспект Достык 188, бизнес-центр Кулан. Без этого рассмотрение не может быть завершено.',
        accidentActReceived:
          'Дальнейшие действия и инструкции вы получите на ваш электронный адрес. Пожалуйста, следите за уведомлениями на почте.',
        isLessThanSixMonths:
          'Срок действия указанного документа истекает менее чем через 6  месяцев или уже истек, что не соответствует требованиям. Пожалуйста, обновите информацию, чтобы продолжить использование сервиса без ограничений.',
        newClaim: 'В настоящее время данные находятся в обработке у менеджера по выплатам.',
        onApproval:
          'Для рассмотрения Вашего обращения по заявленному событию, просим предоставить перечень первичных документов. Следующий список документов будет запрошен после утверждения списка текущих документов.',
      },
    },
    notices: {
      alertContract: 'По вашему заявлению сформирован договор предпенсионного аннуитета.',
      apply: {
        // Казахская локализация по BL-6711 не требуется — строки продублированы русскими,
        // как в соседнем блоке kdpPdHistory.
        consent: {
          badge: {
            declined: 'Согласие отклонено',
            granted: 'Согласие получено',
            required: 'Требуется согласие',
            sent: 'Согласие отправлено',
          },
          confirmed: 'Подтвердил',
          declinedAlert:
            'Согласие отклонено. Без согласия мы не можем продолжить оформление заявки. Вы можете запросить повторно',
          identifierNotFound: 'Введённый ИИН некорректен или не найден в системе',
          introNotice:
            'Необходимо получить согласие потерпевшего на обработку персональных данных. Запросите СМС-подтверждение с номера 1414',
          pendingAlert: 'Проверьте входящее СМС и ответьте на сообщение с номера 1414',
          pendingAlertTitle: 'Согласие ещё не зафиксировано',
          repeat: 'Запросить повторно',
          repeatIn: 'Отправить согласие повторно через {{seconds}} сек',
          request: 'Запросить согласие',
          serviceUnavailable:
            'Сервис согласия временно недоступен. Пожалуйста, попробуйте позже — введённые данные сохранены',
          timeoutAlert: 'Срок действия запроса истёк. Пожалуйста, запросите согласие повторно',
        },
        description: 'Для уведомления страховой компании о наступлении страхового случая необходимо создать извещение.',
        form: {
          alert: 'Өтініш беру үшін барлық міндетті өрістерді толтырыңыз',
          alertTitle: 'Міндетті өрістерді толтырыңыз',
          citizenship: 'Азаматтық',
          contractNumber: 'Номер договора',
          dateAndTime: 'Дата и время',
          dateOfBirth: 'Дата рождения',
          dateOfIssue: 'Дата выдачи',
          death: 'Смерть',
          documentNumber: 'Номер документа',
          documentType: 'Тип документа',
          email: 'E-mail',
          enterMessage: 'Введите сообщение',
          eventHappenned: 'Событие которое произошло',
          eventPlaced: 'Место события',
          expirationDate: 'Дата окончания срока действия',
          female: 'Женский',
          fillDetails: 'Деректерді толтырыңыз:',
          firstName: 'Имя',
          iin: 'ИИН',
          insuredEventDateAndTime: 'Дата и время страхового случая',
          issuingAuthority: 'Орган выдачи документа',
          lastName: 'Фамилия',
          male: 'Мужской',
          middleName: 'Отчество',
          no: 'Нет',
          noIin: 'Нет ИИН',
          nonResident: 'Нерезидент РК',
          occupationalDisease: 'Профессиональное заболевание',
          onsuranceEventDesciption: 'Описание страхового случая',
          phoneNumber: 'Номер телефона',
          registrationAddress: 'Адрес регистрации',
          resident: 'Резидент РК',
          selectContractNumber: 'Выберите номер договора',
          selectCountry: 'Выберите страну',
          selectCountryResidence: 'Резиденттік елді таңдаңыз',
          selectCountryTaxResidence: 'Салықтық резиденттік елді таңдаңыз',
          selectFromTheOptionsBelow: 'Выберите из перечисленных ниже вариантов',
          specifyLocationOfIncident: 'Укажите место проишествия',
          taxResidenceCountry: 'Выберите страну налогового резиденства',
          workInjury: 'Трудовое увечье',
          yes: 'Да',
        },
        identityDocument: 'Документ, удостоверяющий личность',
        title: 'Извещение о страховом случае',
        victimData: 'Данные потерпевшего',
        warning:
          'В случае наступления страхового случая, Вам необходимо создать извещение о страховом случае в течение трёх календарных дней с момента его наступления. Несоблюдение срока может повлиять на рассмотрение и выплату страхового возмещения. После подачи извещения вы сможете перейти к подаче заявления на выплату, приложив необходимые документы.',
      },

      checkCorrect: 'Пожалуйста, проверьте правильность ввода и попробуйте снова.',
      claimStatements: {
        applicationNumber: 'Өтініш №',
        compensationType: 'Өтемақы түрі',
        createdDate: 'Құрылған күні',
        paymentType: 'Төлем түрі',
        status: 'Мәртебесі',
        title: 'Өтініштер',
      },
      contractNum: '№ договора',
      contractPPA: 'Договор ППА',
      enterClaimNumber: 'Введите номер извещения',
      enterClientIdentifier: 'Введите ИИН / БИН клиента',
      enterNoticeId: 'Введите ID извещения',
      enterVictimFio: 'Введите ФИО потерпевшего',
      enterVictimIdentifier: 'Введите ИИН потерпевшего',
      formatDocuments:
        'Допустимые форматы загрузки файлов: pdf, doc, docx, jpg, png, xlsx, xls. Размер загружаемого файл не должен превышать 30 MB.',
      furtherActions: {
        documents: {
          DEATH: {
            copyBankDetails: 'Копия банковских реквизитов счета получателя.',
            copyDocument:
              'Нотариально засвидетельствованная копия документа, подтверждающего право выгодоприобретателя на возмещение вреда в случае смерти работника;',
            digitalCopy: 'Цифровая копия документа, удостоверяющего личность выгодоприобретателя;',
          },
          INJURY_OR_DISEASE: {
            amountSocialPayment:
              'Копия справки территориального подразделения уполномоченного органа о размере назначенной социальной выплаты по случаю утраты трудоспособности либо отказе в ее назначении;',
            confirmationMedicalExpenses:
              'Документы, подтверждающие фактически понесенные расходы на лечение (счет-фактура, кассовый чек и другие);',
            copyBankDetails: 'Копия банковских реквизитов счета получателя.',
            copyDisability: 'Копия справки об инвалидности;',
            copyLossStatement:
              'Копия справки территориального подразделения уполномоченного органа об установлении утраты профессиональной трудоспособности;',
            copyNeedHelp:
              'Копия справки территориального подразделения уполномоченного органа о нуждаемости в дополнительных видах помощи и ухода;',
            digitalCopy: 'Цифровая копия документа, удостоверяющего личность пострадавшего работника;',
            documentPresenceDisease:
              'Копия документа, подтверждающего наличие профессионального заболевания, выданная организацией здравоохранения, оказывающей специализированную медицинскую помощь в области профессиональной патологии и экспертизы;',
          },
        },
        listDocuments: 'Список необходимых документов',
        sendTo:
          'Оригиналы документов или нотариально заверенные копии направлять по адресу: A25D6X2, Республика Казахстан, г. Алматы, проспект Достык, 188, БЦ Kulan, 2 этаж, тел.: +77003702128, 8 (727) 248 62 74, e-mail: claims@bcclife.kz',
        whatsNext: 'Что дальше',
      },
      kdpPdHistory: {
        checkType: 'Тип проверки',
        consentResponseAt: 'Дата и время согласия/несогласия',
        consentSentAt: 'Дата и время отправки согласия',
        consentStatus: 'Статус согласия',
        dateTime: 'Дата и время согласия',
        getSMSAgreement: 'Получить СМС согласие',
        smsAgreementSuccessfullySent: 'СМС согласие успешно отправлено',
        title: 'Согласие потерпевшего',
      },
      notFound:
        'Не найдено. Нет извещений, соответствующих вашим условиям. Если вы применили фильтры или поисковый запрос - попробуйте их изменить.',
      notice: 'Извещение',
      noticeDate: 'Дата извещения',
      noticeId: 'ID извещения',
      noticeNum: '№ извещения',
      noticeNumber: 'Номер извещения',
      notices: 'Журнал извещений',
      noticeType: 'Тип извещения',
      notificationNS: 'Извещение НС',
      notificationPPA: 'ППА шарты',
      oppvCheckRequest: {
        eventId: 'ID события',
        registrationEventDateTime: 'Дата и время регистрации события',
        responseCode: 'Код ответа',
        responseCodeDescription: 'Описание кода ответа',
        title: 'Регистрация проверки по ОППВ в ЕСБД',
      },
      oppvCheckResponse: {
        mandatoryProfessionalInsuranceContributions: 'Обязательные профессиональные страховые взносы',
        messageId: 'ID сообщения',
        paymentDate: 'Дата платежа',
        paymentPeriod: 'Период платежа',
        personCitizenship: 'Гражданство лица',
        personCitizenshipOptions: {
          '1': 'Соответствует',
          '2': 'Не соответствует',
        },
        personOppvOptions: {
          '1': 'Не соответствует (меньше 84 месяца)',
          '2': 'Cоответствует, 84 месяца и более (исключаем платежи, по которым осуществлен возврат плательщику)',
        },
        personStateOptions: {
          '1': 'Соответствует',
          '2': 'Не соответствует',
        },
        personStatus: 'Статус лица',
        personWorkingConditionOptions: {
          '1': 'Расторжение с трудовым договором (вредные условия труда)',
          '2': 'Переход на легкие условия труда (заключение дополнительного договора)',
          '3': 'Отсутствие договора',
        },
        reportDate: 'Дата отчета',
        requestId: 'ID запроса',
        responseDate: 'Дата ответа',
        responseDateCurrent: 'Дата ответа (Текущее время запроса)',
        title: 'Результат проверки по ОППВ в ЕСБД',
        workingConditions: 'Рабочие условия',
      },
      paymentApplication: {
        blockTitle: 'Төлемге өтініш',
        compensationType: {
          sanatoriumLimitText: 'Бұл өтемақыға өтініш бұрын берілген. Өтемақының басқа түрін таңдаңыз',
          sanatoriumLimitTitle: 'Назар аударыңыз! Сізде санаторий-курорттық емделуге өтініш бар',
          selectTypeOfRefund: 'Өтемақы түрін таңдаңыз',
          typeOfRefund: 'Өтемақы түрі',
        },
        consent:
          '"Жалғастыру" түймесін басу арқылы мен <termsConditionsLink>қызметкердің дербес деректерін жинауға, өңдеуге және пайдалануға</termsConditionsLink> өз келісімімді беремін',
        continueButton: 'Жалғастыру',
        createButton: 'Төлемге өтініш құру',
        documents: {
          DEATH: {
            bankDetails: 'Банк деректемелері',
            confirmationExpenses: 'Шеккен шығындарды растайтын құжаттар',
            otherDocuments: 'Өзге құжаттар',
          },
          INJURY_OR_DISEASE: {
            bankDetails: 'Банк деректемелері',
            certificateOfNeed: 'Мұқтаждық туралы анықтама',
            confirmationExpenses: 'Шеккен шығындарды растайтын құжаттар',
            otherDocuments: 'Өзге құжаттар',
          },
        },
        documentsBannerText:
          'Төлемге өтініш беру үшін құжаттар тізбесін жинап, ұсыну қажет. Бұл құжаттардың электрондық нұсқасы бар екеніне көз жеткізіңіз.',
        documentsBannerTitle: 'Назар аударыңыз! Құжаттарды жүктеу қажет',
        introTitle: 'Сақтандыру жағдайы бойынша төлемге өтініш беру',
        listDocuments: 'Қажетті құжаттар тізімі',
        originalDocumentBanner:
          'Назар аударыңыз! Бұл құжатты сақтандыру компаниясына түпнұсқада кез келген ыңғайлы тәсілмен: курьермен, пошта арқылы немесе кеңсеге жеке барып тапсыру қажет. Сақтандыру компаниясының мекенжайы: Алматы қ., Достық даңғылы 188, «Күлан» бизнес-орталығы',
        step1: {
          clarifyPdlLabel: 'ҚМТ-ны нақтылаңыз',
          emailLabel: 'E-mail',
          pdlHint:
            'жауапты мемлекеттік лауазымды атқаратын тұлға; лауазымды тұлға; мемлекеттік функцияларды орындауға уәкілетті тұлға; мемлекеттік ұйымда немесе квазимемлекеттік сектор субъектісінде басқарушылық функцияларды орындайтын тұлға; шет мемлекеттің заң шығарушы, атқарушы, әкімшілік, сот органдарында немесе қарулы күштерінде қандай да бір лауазымды атқаратын, тағайындалатын немесе сайланатын тұлға; шет мемлекет үшін қандай да бір қоғамдық функцияны орындайтын тұлға; халықаралық шарттар мәртебесі бар келісімдер негізінде мемлекеттер құрған ұйымдарда басшылық лауазымды атқаратын тұлға.',
          pdlQuestion: 'Зардап шегуші, жұбайы немесе жақын туыстары ҚМТ-ға жата ма?',
          title: 'Сақтандыру жағдайы бойынша төлемге өтініш',
          victimInfoTitle: 'Зардап шегуші туралы мәліметтер',
        },
        step2: {
          dateInsuredEvent: 'Сақтандыру жағдайының күні мен уақыты',
          descriptionNs: 'Жазатайым оқиғаның сипаттамасы',
          disabilityPercent: 'Зардап шегушінің кәсіби еңбекке қабілеттілігін жоғалту дәрежесі, %',
          event: 'Болған оқиға',
          eventLocation: 'Оқиға орны',
          reasonNs: 'Жазатайым оқиғаның себебі',
        },
        step3: {
          beneficiaryLabel: 'Пайда алушы',
          enterBankRequisites: 'Банк деректемелерін енгізіңіз',
          hint: 'Пайда алушы — сақтандыру төлемін алатын тұлға.',
          ibanHint: 'IBAN KZ-пен басталуы керек',
          otherConsentNotice:
            'Пайда алушының дербес деректерді өңдеуге келісімін алу қажет. 1414 нөмірінен SMS-растауды сұраңыз',
          pdlQuestion: 'Пайда алушы, жұбайы немесе жақын туыстары ҚМТ-ға жата ма?',
          selectVariant: 'Нұсқалардың бірін таңдаңыз',
          title: 'Пайда алушы туралы ақпарат',
        },
        step4: {
          title: 'Қажетті құжаттарды жүктеңіз',
        },
        step5: {
          applicationInfo: 'Өтініш туралы мәліметтер',
          applicationType: 'Өтініш түрі',
          confirmButton: 'Растаймын',
          consentCheckbox:
            'Мен <documentLink>Сақтандыру жағдайы бойынша төлемге өтініш</documentLink> шарттарымен таныстым және келісемін.',
        },
        steps: {
          beneficiary: 'Пайда алушы',
          confirmation: 'Растау',
          descriptionNs: 'Жазатайым оқиғаның сипаттамасы',
          documents: 'Құжаттар',
          info: 'Мәліметтер',
        },
        success: {
          applicationNumber: 'Өтініш №',
          applicationPageButton: 'Өтініш беті',
          description:
            'Өтініш сәтті жіберілді және қазір өңделуде. Сақтандыру компаниясының шешімін күтіңіз — ол қабылданғаны туралы сізге хабарлаймыз.',
          downloadButton: 'Өтінішті жүктеп алу',
          title: 'Рахмет! Біз сіздің өтінішіңізді алдық',
        },
      },
      title: 'Извещения',
      uploadDocument: 'Загрузите документ',
      victim: {
        applicationStatus: 'Статус заявки',
        documentType: 'Тип документа',
        expirationDate: 'до истечения срока менее 6 месяцев',
        identityDocument: 'Документ удостоверяющий личность',
        issueDate: 'Дата выдачи',
        issuedBy: 'Орган выдачи документа',
        validUntil: 'Действует до',
        victimData: 'Данные потерпевшего',
        victimPerson: 'Потерпевший',
      },
    },
    payment: {
      agree: 'Келісемін',
      agreeText: 'Мен сомамен таныстым және жеке деректерімді жинауға, өңдеуге және пайдалануға келісімімді беремін',
      disagree: 'Келіспеймін',
      info: 'Банктің БСК:',
      nameBank: 'Банктің атауы:',
      number: 'Шот нөмірі:',
      requisits: 'Төлем үшін банктік шоттың деректемелері:',
      result: 'Сақтандыру төлемінің қорытынды сомасы:',
      send: 'Жіберу',
    },
    personalDataProcessing:
      'Нажимая кнопку "Далее" я подтверждаю <termsConditionsLink>на сбор, обработку и использование персональных данных работника</termsConditionsLink>',
    product: 'Өнім',
    statement: 'Өтініш',
    stepAgreement: {
      answerSomeQuestions: 'Ответьте на несколько вопросов и узнайте, что будет дальше',
      applyStatement:
        'Теперь, когда страховой случай зарегистрирован, вы можете подать заявление на получение страховой выплаты.',
      startProcedure: 'Это необходимо для запуска процедуры рассмотрения и принятия решения о выплате.',
      title: 'Подача заявления на заключение предпенсионного аннуитета и осуществление страховой выплаты',
    },
    stepWrapper: {
      application: 'Заявление на заключение предпенсионного аннуитета и осуществление страховой выплаты',
      confirm: 'Подтверждение',
      fillBasicInformation: 'Заполните основную информацию ',
      policyholder: 'Данные страхователя',
      victim: 'Сведения о потерпевшем',
    },
    terminations: {
      applicationHasBeenRejected: 'Сіздің өтінішіңіз қабылданбады',
      applicationHasBeenRejectedDescription: 'Құжаттар талаптарға сай емес, құжатты(тарды) ауыстыру қажет',
      applicationOfTermination: 'Бұзу туралы өтініш',
      applicationsForTermination: 'Бұзу туралы өтініштер',
      button: 'Жалғастыру',
      cancel_contract: 'Сақтандыру шартынан бас тарту',
      documentHelperTextTypes: {
        BANK_ACCOUNT_AVAILABILITY: 'Скачайте справку в мобильном приложении Банка',
        EARLY_LOAN_REPAYMENT:
          'Для получения справки обратитесь в филиал Банка или скачайте справку в мобильном приложении Банка',
        IDENTITY_CARD: 'Сканированный/Сфотографированный документ вашего удостоверения личности',
        INVALID_LOAN_AGREEMENT_RECOGNITION: 'Для получения справки обратитесь в филиал Банка',
      },
      documentsList: 'Құжаттар тізімі',
      faqs: {
        description: {
          step1:
            'Қарыз алушының өмірін жинақтаушы емес сақтандыру шартын <highlightedText>қарыз толық көлемде мерзімінен бұрын өтелген кезде</highlightedText> сақтандыру арқылы қорғаудың қолданылу мерзімі аяқталғанға дейін бұзуға болады. Клиент сақтандыру шарты қолданылған уақытқа пропорционалды сақтандыру сыйақысының бір бөлігін және <highlightedText>10%</highlightedText> ұстап қала отырып, сақтандыру сыйақысын қайтарып ала алады.',
          step2:
            'Берешек туралы анықтаманы банк филиалындағы менеджерден немесе <highlightedText>Банк ЦентрКредит</highlightedText> мобильді қосымшасы арқылы алуға болады. Басты беттен <highlightedText>«Басқа сервистер»</highlightedText> бөлімін, содан кейін <highlightedText>«Анықтама алу»</highlightedText> бөлімін таңдаңыз, одан әрі <highlightedText>«Берешектің жоқтығы туралы анықтама»</highlightedText> тармағын таңдаңыз. Анықтамада QR-қолтаңба болуы тиіс.',
          step3:
            'Шоттың бар екені туралы анықтаманы банк бөлімшесінен немесе Өз банкіңіздің мобильді қосымшасынан (Kaspi, Halyk, BCC) алуға болады. Карточка бойынша қосымша ақпаратқа басып, Сіз <highlightedText>«Шоттың бар екені туралы анықтама»</highlightedText> бөлімін таба аласыз.',
          step4:
            'Сақтандыру сыйақысын қайтару сақтандыру шарты қолданылған мерзімге пропорционалды сақтандыру сыйақысын шегере отырып, әкімшілік шығындарды өтеу үшін 10% ұстап қалумен жүзеге асырылады.',
        },
        highlighted: {
          step1: 'Отказ от договора займа в течение 14 дней с даты заключения договора страхования.',
          step2: 'Отказ от договора страхования в течение 14 дней с даты заключения.',
          step3: 'Отказ от договора страхования после 14 дней с даты заключения.',
          step4: 'Досрочное погашение займа.',
        },
        points: {
          stepFour1: 'Необходимо отметить соответствующий пункт в заявлении;',
          stepFour2: 'Требуется справка с Банка о досрочном погашении займа.',
          stepOne1: 'Өтініште тиісті тармақты белгілеу қажет.',
          stepOne2: 'Қарыздың мерзімінен бұрын өтелгені туралы банктен анықтама талап етіледі.',
          stepThree: 'Необходимо отметить соответствующий пункт в заявлении.',
          stepTwo: 'Необходимо отметить соответствующий пункт в заявлении.',
        },
        questions: {
          step1: 'Сақтандыру шартын қалай бұзуға болады?',
          step2: 'Берешек туралы анықтаманы қалай алуға болады?',
          step3: 'Шоттың бар екені туралы анықтаманы қалай алуға болады?',
          step4: 'Төлем сомасы қалай есептеледі?',
        },
        titleText: {
          step1: ' Клиент может расторгнуть договор страхования с возвратом страховой премии полностью.',
          step2:
            ' Клиент может расторгнуть договор страхования по причине, не связанной с отказом от договора займа, с возвратом страховой премии за вычетом части страховой премии пропорционально времени, в течение которого действовал договор страхования и с удержанием 10%.',
          step3:
            ' Клиент может расторгнуть договор страхования по причине, не связанной с отказом от договора займа, без возврата страховой премии.',
          step4:
            ' Клиент может расторгнуть договор страхования по причине досрочного погашения займа с возвратом страховой премии за вычетом части страховой премии пропорционально времени, в течение которого действовал договор страхования и с удержанием 10%.',
        },
      },
      lastUpdateTerminationDate: 'Соңғы жаңарту күні',
      notificationsNumber: 'Хабарлама нөмірі',
      pepRelatedHelperText:
        'Қоғамдық лауазымды тұлға – жауапты мемлекеттік лауазымды атқаратын тұлға; лауазымды тұлға; мемлекеттік функцияларды орындауға уәкілетті тұлға; мемлекеттік ұйымдағы немесе квазимемлекеттік сектор субъектісіндегі басқарушылық функцияларды орындайтын тұлға; тағайындалатын немесе сайланатын, заң шығарушы, атқарушы, әкімшілік, сот органдарында немесе шетел мемлекетінің қарулы күштерінде кез келген лауазымды атқаратын тұлға; шетел мемлекеті үшін қандай да бір қоғамдық функцияны орындайтын тұлға; халықаралық шарт мәртебесіне ие келісімдер негізінде елдер құрған ұйымдардағы жетекші лауазымды атқаратын тұлға',
      pepRelatedLabelText:
        'Сіз қоғамдық лауазымды тұлғаға, оның жұбайына (жұбайына) және жақын туыстарына тиесілі және/немесе қатысыңыз бар ма?',
      reason: 'Бұзу себебі',
      sentToTerminationAt: 'Өтініштің келіп түскен күні',
      settings: {
        step1: 'Скачайте бланк заявления на расторжение. ',
        step2: 'Заполните заявление в соответствии с предоставленной формой.',
        step3:
          'Распечатайте, подпишите и отправьте его по адресу: Республика Казахстан, г. Алматы, проспект Достык, д. 188 в течение 14 дней с момента заключения Договора займа',
      },
      terminationHasAlreadyCreated: 'Бұзу қазірдің өзінде жасалған',
      terminationHasAlreadyCreatedMessage:
        'Осы келісімшарт бойынша бұзу процесі қазірдің өзінде басталған. Толық мәліметті көру үшін жоғарғы мәзірдегі <strong>"Бұзулар"</strong> бөліміне өтіңіз.',
      terminations: 'Бұзу',
      terminationType: 'Бұзу түрі',
      updatedTerminationAt: 'Өтініштің жаңартылған күні',
    },
  },
};
